import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { flushOfflineQueue } from '../store/offlineQueue';

/**
 * Replays the offline queue when the connection returns (and once on mount),
 * then invalidates the affected queries so the UI reflects the synced data.
 */
export function useOfflineSync(): void {
  const queryClient = useQueryClient();

  useEffect(() => {
    const run = async () => {
      const synced = await flushOfflineQueue();
      if (synced > 0) {
        queryClient.invalidateQueries({ queryKey: ['shopping'] });
        queryClient.invalidateQueries({ queryKey: ['items'] });
      }
    };
    void run();
    window.addEventListener('online', run);
    return () => window.removeEventListener('online', run);
  }, [queryClient]);
}
